import React from 'react';
import StoreCtaButtons from './StoreCtaButtons';
import { useRevealInView } from '../lib/landingMotion';

export default function ContactSection() {
    const ctaMotion = useRevealInView({ threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    return (
            <section
                ref={ctaMotion.ref}
                className={`landing-section marketing-cta ${ctaMotion.isVisible ? 'is-visible' : ''}`}
                aria-labelledby="contact-heading"
                id="contact"
                data-reveal-root
            >
                <div className="site-container marketing-cta__inner">
                    <h2 className="marketing-cta__title" id="contact-heading" data-reveal-item style={{ '--delay': '0ms' }}>
                        <span>Start</span> your
                        <br />
                        journey <span>today</span>
                    </h2>

                    <div className="marketing-cta__actions" data-reveal-item style={{ '--delay': '110ms' }}>
                        <StoreCtaButtons variant="cta" />
                    </div>
                </div>
            </section>
    );
}
